import { useQuery } from 'react-query';
import { queryClient, request } from 'utils';

export interface Follower {
  desc: UserDesc;
  follower_count: number;
  id: string;
  is_following: boolean;
  is_followed: boolean;
  stats: Stats;
  usd_value: number;
  relation?: string;
  create_at: number;
}

export type Order = '+from_usd_value' | '-from_usd_value' | '+to_usd_value' | '-to_usd_value';

const FollowListQuery = {
  /**
   * /user/followers
   * /user/following_list
   */
  user: '/user/',
  /**
   * /official/followers
   */
  official: '/official/',
  token: '/token/',
  collection: '/collection/',
};

export type FollowListFrom = keyof typeof FollowListQuery;

export const useFollowList = ({
  id,
  start = 0,
  limit = 20,
  from = 'user',
  isFollowing,
  orderBy,
  chainId,
}: {
  id: string;
  start?: number;
  limit?: number;
  from?: FollowListFrom;
  isFollowing?: boolean;
  orderBy?: string;
  chainId?: string;
}) => {
  const path = `${FollowListQuery[from]}${isFollowing ? 'following_list' : 'followers'}`;

  const query = useQuery(
    [path, id, start, limit, orderBy, chainId],
    () => {
      const params: Record<string, any> = {
        id,
        start,
        limit,
        order_by: orderBy,
      };

      if (chainId) {
        params.chain_id = chainId;
      }

      return request.get<{
        followers?: Follower[];
        following_list?: Follower[];
        total_count: number;
      }>(path, params, {
        timeout: 15000,
      });
    },
    {},
  );

  return query;
};

export const invalidFollowList = (type: FollowListFrom, id: string, isFollowing = false) => {
  queryClient.invalidateQueries([
    `${FollowListQuery[type]}${isFollowing ? 'following_list' : 'followers'}`,
    id,
  ]);
};
